<template>
  <accordion-item-fi
    v-if="hasContent"
    class="accordion-content-fi"
    header-tag="h3"
    ignore-others
    scroll-to
  >
    <template #header>
      {{ $dict.get('product-Catalog.Accordions.Content') }}
    </template>
    <template #content>
      <div class="accordion-content-fi__content">
        <div class="accordion-content-fi__column">
          <richtext-fi
            v-if="hasPackageContent"
            class="accordion-content-fi__text"
            :html-content="{ value: textListValue(textList, 'PACKAGE_CONTENT') }"
          />
          <richtext-fi
            class="accordion-content-fi__text"
            :html-content="{ value: attributeValue(attributes, 'INHALT') }"
          />
        </div>
        <div
          v-if="documents?.length"
          class="accordion-content-fi__links"
        >
          <link-fi
            v-for="document in documents"
            :key="document.Name"
            :href="document.Url"
            target="_blank"
            rel="noopener"
            class="accordion-content-fi__link"
            :size="18"
            primary
          >
            {{ document.CharacteristicValueNames?.[0] }}
          </link-fi>
        </div>
        <div
          v-if="hasPackageContentMedia"
          :class="{
            'accordion-content-fi__media': true,
            'accordion-content-fi__media--first':
              (!documents || (documents && !documents.length)) &&
              !attributeValue(attributes, 'INHALT') &&
              !hasPackageContent,
          }"
        >
          <div
            v-for="media in packageContentMedia"
            :key="media.Url"
            class="accordion-content-fi__media-item"
          >
            <cloud-image-fi
              :src="media.Url"
              :alt="media.label"
              :sizes="{
                xxs: { h: 115 },
                xs: { h: 115 },
                sm: { h: 125 },
                md: { h: 142 },
                lg: { h: 142 },
                xl: { h: 142 },
              }"
              params="func=bound"
              do-not-replace-url
            />
          </div>
        </div>
      </div>
    </template>
  </accordion-item-fi>
</template>

<script>
import { AccordionItemFi, CloudImageFi, LinkFi, RichtextFi } from 'atoms';

import breakpointMixin from '@/mixins/breakpointMixin.vue';
import catalogAttributesMixin from '@/mixins/catalogAttributesMixin.vue';
import catalogTextListMixin from '@/mixins/catalogTextListMixin.vue';

export default {
  name: 'AccordionContentFi',
  components: {
    AccordionItemFi,
    RichtextFi,
    LinkFi,
    CloudImageFi,
  },
  mixins: [breakpointMixin, catalogAttributesMixin, catalogTextListMixin],
  props: {
    catalogData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    attributes() {
      return this.catalogData?.Attributes;
    },
    packageContentMedia() {
      return this.catalogData?.Media?.filter((i) => i.Type === 'Package content') || [];
    },
    hasPackageContentMedia() {
      return this.isFite && this.packageContentMedia.length;
    },
    hasContent() {
      return (
        (this.attributes &&
          this.attributeName(this.attributes, 'INHALT') &&
          this.attributeValue(this.attributes, 'INHALT')) ||
        this.hasPackageContent ||
        this.hasPackageContentMedia
      );
    },
    documents() {
      if (this.catalogData?.Documents?.AdditionalDocuments) {
        return this.catalogData.Documents.AdditionalDocuments.filter(
          (el) => el.Type === 'Installation Instructions',
        );
      }

      return null;
    },
    textList() {
      return this.catalogData?.TextList;
    },
    hasPackageContent() {
      return this.textListValue(this.textList, 'PACKAGE_CONTENT') && this.isFite;
    },
  },
};
</script>

<style src="./accordion-content-fi" />
